<template>
  <div style="padding: 32px 40px; background: #f8f8f8; min-height: 90vh;">

    <div style="font-size: 12px; color: #9a9a9a; margin-bottom: 6px; font-weight: 500;">Financeiro / Notas / Conferência Diária</div>

    <div style="display:flex; align-items:flex-end; justify-content:space-between; margin-bottom: 24px; flex-wrap: wrap; gap: 16px;">
      <div>
        <h1 style="margin:0; font-size: 26px; font-weight: 700; color: #1f1f1f;">Conferência diária de notas emitidas</h1>
        <p style="margin: 6px 0 0; font-size: 13.5px; color: #7c7c7c; max-width: 640px;">
          Acompanhe o que a fila de confirmação de protocolo processou no dia — sem precisar entrar nota por nota.
        </p>
      </div>

      <DateShortcutFilter v-model="dataSelecionada" @input="carregar" />
    </div>

    <div style="display:grid; grid-template-columns: repeat(4, minmax(0,1fr)); gap: 18px; margin-bottom: 24px;">
      <ResumoCard label="Total no dia" :valor="resumo.total" cor="#5b5b5b" bg="#f1f2f4" icone="total" />
      <ResumoCard label="Confirmadas" :valor="resumo.confirmadas" cor="#28c76f" bg="#e8fce8" icone="check" />
      <ResumoCard label="Falharam" :valor="resumo.falhadas" cor="#ea5455" bg="#fce3e3" icone="alerta" />
      <ResumoCard label="Processando" :valor="resumo.processando" cor="#00BBA2" bg="#dff2f0" icone="relogio" />
    </div>

    <DataTable
      :columns="colunas"
      :rows="notasPagina"
      :loading="carregando"
      :pagina="pagina"
      :total-paginas="totalPaginas"
      :total="notas.length"
      empty-text="Nenhuma nota emitida nessa data."
      @mudar-pagina="p => (pagina = p)"
    >
      <template #cell-situacao="{ row }">
        <StatusBadge :situacao="row.situacao" />
      </template>

      <template #cell-motivo="{ row }">
        <div
          v-if="row.situacao === 'falhou' && row.erro"
          style="display:flex; align-items:center; gap:8px; background:#fdf3f3; border:1px solid #f6d9d9; border-radius:6px; padding:8px 12px; max-width: 460px;"
        >
          <span style="font-size:12.5px; color:#8a3d3d; line-height:1.35;">{{ row.erro.correcao || row.erro.mensagem }}</span>
        </div>
        <span v-else style="color:#c4c4c4;">—</span>
      </template>

      <template #cell-email="{ row }"><IndisponivelBadge :valor="row.email_enviado" /></template>
      <template #cell-whatsapp="{ row }"><IndisponivelBadge :valor="row.whatsapp_enviado" /></template>
    </DataTable>

  </div>
</template>
<script>
import DateShortcutFilter from "@/components/default/DateShortcutFilter.vue";
import DataTable from "@/components/default/DataTable.vue";
import StatusBadge from "@/components/default/StatusBadge.vue";
import IndisponivelBadge from "@/components/default/IndisponivelBadge.vue";
import ResumoCard from "./components/ResumoCard.vue";
import NotaStatusDiarioService from "@/services/NotaStatusDiarioService.js";

const ITENS_POR_PAGINA = 10;

export default {
  name: "ConferenciaDiaria",
  components: { DateShortcutFilter, DataTable, StatusBadge, ResumoCard, IndisponivelBadge },
  data() {
    return {
      dataSelecionada: "",
      notas: [],
      resumo: { total: 0, confirmadas: 0, falhadas: 0, processando: 0 },
      carregando: false,
      pagina: 1,
      colunas: [
        { key: "rps", label: "RPS", width: "110px" },
        { key: "numero", label: "Nº Protocolo", width: "130px" },
        { key: "situacao", label: "Situação", width: "150px" },
        { key: "motivo", label: "Motivo (quando falhou)" },
        { key: "email", label: "E-mail", width: "140px" },
        { key: "whatsapp", label: "WhatsApp", width: "140px" }
      ]
    };
  },
  computed: {
    totalPaginas() {
      return Math.max(1, Math.ceil(this.notas.length / ITENS_POR_PAGINA));
    },
    notasPagina() {
      const inicio = (this.pagina - 1) * ITENS_POR_PAGINA;
      return this.notas.slice(inicio, inicio + ITENS_POR_PAGINA);
    }
  },
  methods: {
    async carregar() {
      this.carregando = true;
      this.pagina = 1;
      try {
        const resposta = await NotaStatusDiarioService.buscar(this.dataSelecionada);
        this.notas = resposta.notas || [];
        this.resumo = resposta.resumo || { total: 0, confirmadas: 0, falhadas: 0, processando: 0 };
      } catch (err) {
        this.$httpErrors(err);
      } finally {
        this.carregando = false;
      }
    }
  }
};
</script>
